import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'contract-interest-third-party-search-dialog',
    templateUrl: './contract-interest-third-party-search-dialog.component.html',
    providers: [DataService]
})
export class ContractInterestThirdPartySearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Entity';
        this.model.title = 'Select Third Party';

        this.model.criteria.Max = this.model.currentOptions.maxRows;
        this.model.criteria.Role_Type = 'TP';
        this.model.criteria.json = 'CT2';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
